<template>
  <div>
    <!-- <cards
      :id="order.client.id"
      @input="changeCard"
      v-model="order.card_id"
      :card="order.card"
    /> -->

    <!-- <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div> -->
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {
    Cards: () => import("@/components/Item/Order/Client/Cards"),
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    // async changeCard(val) {
    //   await this.updateOrder({ card_id: val });
    // },
    send() {
      this.$loading(true);
    },
  },
  data() {
    return {
      data: {
        client_first_name: null,
        client_last_name: null,
        client_family_name: null,
        client_address: null,
        client_phone_number: null,
        client_pinfl: null,
        client_passport: null,
        client_birthday: null,
        client_card_number: null,
        client_card_exp: null,

        client_photo_passport_id: null,
        client_photo_passport_address: null,
        client_photo_passport_selfie: null,
      },
    };
  },
};
</script>

